module.exports = require("@mui/icons-material/Fullscreen");